import * as React from "react";
import { Link } from 'gatsby-theme-material-ui';
import Chip from '@material-ui/core/Chip';

export default function BlogChip(props) {
  const component = props.to ? Link : "div";
  const color = props.color || "primary";
  const variant = props.variant || "outlined";
  const size = props.size || "small";

  return (
    <Chip
      component={component}
      color={color}
      variant={variant}
      size={size}
      clickable={props.to !== undefined}
      {...props}
      sx={{ marginRight: 1, ':hover': { textDecoration: 'none' } }}
    />
  );
}